<template>
  <BModal
    :id="id"
    hide-footer
    hide-header
    :centered="true"
    content-class="rounded-lg"
    @hidden="$emit('hidden')"
  ><div class="p-1">
    <h1 class="font-semibold text-[18px] text-[#333333] text-center mb-2">
      Cek Estimasi Saldo
    </h1>
    <div class="flex items-center gap-[.75rem] mb-2 bg-[#F8F8F8] p-[.75rem] rounded-lg">
      <span class="k-card text-[16px]" />
      <p class="m-0 font-medium">
        {{ account.name }}
      </p>
    </div>
    <div class="flex items-center justify-between mb-1">
      <span class="font-medium">Detail Saldo</span>
      <span
        v-if="adAccountType[accountTypeProperty(account)]"
        :class="adAccountType[accountTypeProperty(account)].class"
      >{{ adAccountType[accountTypeProperty(account)].text }}</span>
    </div>
    <div class="border border-[#D9D9D9] rounded-lg p-2 grid grid-cols-2 gap-x-6 gap-y-4 mb-2">
      <span class="text-[#626262]">ID Bussiness Manager</span>
      <span class="font-semibold">{{ account.bm_id }}</span>
      <span class="text-[#626262]">ID Ad Account</span>
      <span class="font-semibold">{{ account.ad_account_id }}</span>
      <div class="flex items-center gap-3">
        <span class="text-[#626262]">Status Akun</span>
        <span
          v-b-tooltip.html.hover="{
            title: tooltipContent(`Status akun saat ini ${statusAccount.tooltip}`),
            customClass: 'dark-tooltip'
          }"
          class="k-info-circle text-[#08A0F7]"
        />
      </div>
      <div class="flex items-center gap-[.5rem]">
        <span
          class="rounded-full p-[3px]"
          :class="`bg-[${statusAccount.color}]`"
        />
        <span
          class="font-semibold"
          :class="`text-[${statusAccount.color}]`"
        >
          {{ statusAccount.label }}
        </span>
      </div>
      <div class="flex items-center gap-3">
        <span class="font-semibold">Estimasi Saldo</span>
        <span
          v-b-tooltip.html.hover="{
            title: tooltipContent(`Perkiraan estimasi saldo saat ini ${estimateBalanceTooltip}`),
            customClass: 'dark-tooltip'
          }"
          class="k-info-circle text-[#08A0F7]"
        />
      </div>
      <span class="font-semibold">{{ account.estimated_balance ? IDR(account.estimated_balance) : 'Rp. -' }}</span>
    </div>
    <b-button
      block
      variant="primary"
      @click="$bvModal.hide(id)"
    >Tutup</b-button>
  </div>
  </BModal>
</template>

<style scoped>
.bg-[\#34A770] {
    background-color: #34A770;
}

.text-[\#34A770] {
    color: #34A770;
}

.bg-[\#E31A1A] {
    background-color: #E31A1A;
}

.text-[\#E31A1A] {
    color: #E31A1A;
}
</style>

<script>
import { IDR } from '@/libs/currency'
import { dateFormat } from '@/@core/mixins/ui/date'

export default {
  name: 'ModalEstimateBalance',
  mixins: [dateFormat],
  props: {
    id: {
      type: String,
      default: 'modal-estimate-balance',
    },
    account: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      IDR,
      adAccountType: {
        whitelist: { class: 'ad-type-badge-blue', text: 'Whitelisted' },
        cpastokopedia: { class: 'ad-type-badge-green', text: 'CPAS' },
        cpasshopee: { class: 'ad-type-badge-orange', text: 'CPAS' },
        cpas: { class: '', text: 'CPAS' },
      },
    }
  },
  computed: {
    statusAccount() {
      if (!this.account.account_status) return { color: '', label: '-', tooltip: '-' }
      return this.account.account_status === 'active' ? { color: '#34A770', label: 'Aktif', tooltip: 'aktif' } : { color: '#E31A1A', label: 'Nonaktif', tooltip: 'nonaktif' }
    },
    estimateBalanceTooltip() {
      if (!this.account.estimated_balance_synced_at) return '-'
      return this.dateFormat(this.account.estimated_balance_synced_at, 'dd mmmm yyyy | HH:MM')
    },
  },
  methods: {
    accountTypeProperty(account) {
      return `${account.ad_account_type}${account.marketplace || ''}`
    },
    tooltipContent(text) {
      return `<div class="d-flex align-items-center"><span class="k-info-circle me-2"></span><span class="font-medium text-left">${text}</span></div>`
    },
  },
}
</script>
